<div [hidden]="isLoading">
  <router-outlet></router-outlet>
</div>
<ngx-spinner class="black-overlay" bdColor="rgb(51,51,51)" size="medium" color="#fff" type="ball-triangle-path">
    <p style="font-size: 20px; color: white">{{spinnerMsg}}</p>
</ngx-spinner>
<div data-iframe-height>
    <!-- this is needed for embedded iframe -->
</div>
